import axios from "axios";
import {Message, MessageBox} from "element-ui";
import store from "../store";
import Vue from "vue";
import router from "../router/index";
import {getToken} from "@/utils/auth";

// 创建axios实例
// const baseUrl = "http://admin.tianmai.cn";
// const baseUrl = "http://localhost:1337";
// const baseUrl = "http://shouye.udbeing.com";
const baseUrl = "http://shouye.udbeing.com";

const instance = axios.create({
	baseURL: baseUrl, // api的base_url
	timeout: 15000 // 请求超时时间
});

const request = function(type, api, params) {
	const _loading = Vue.$loading.show();
	return new Promise(function(resolve, reject) {
		if (type === "get") {
			instance
				.get(api, {params: params})
				.then(response => {
					_loading.hide();
					const _data = response.data;
					processResult(_data, resolve(_data));
				})
				.catch(err => {
					_loading.hide();
					reject(err);
				});
		} else {
			instance
				.post(api, params)
				.then(response => {
					_loading.hide();
					const _data = response.data;
					processResult(_data, resolve(_data));
				})
				.catch(err => {
					_loading.hide();
					reject(err);
				});
		}
	});
};

const processResult = function(data, resolve) {
	if (data.code === 200) {
		resolve();
	} else if (data.code === 401) {
		router.push({path: "/admin-login"});
	}
	if (data.message) {
		Vue.$message({
			message: data.message,
			type: "error",
			offset: 100,
			center: true
		});
	}
};

export {request, baseUrl};



// WEBPACK FOOTER //
// ./src/utils/request.js